import BootstrapTooltip from "@/react/bootstrap/components/BootstrapTooltip";
import NavFontsCreate from "@/react/story/components/navs/NavFontsCreate";
import { useFonts } from "@/react/story/providers/FontsContext";
import { type Font, FontFormatEnum, TypeEnum } from "@/react/story/types";
import InitUtils from "@/react/story/utils/InitUtils";
import { useState } from "react";
import { ReactSortable } from "react-sortablejs";

export default function NavFonts() {
    const Fonts = useFonts();

    const [ newFont, setNewFont ] = useState<Font | null>(null);

    const saveNewFont = async (font: Font) => {
        font.weights = font.weights.sort();
        await Fonts.save(font);
        setNewFont(null);
    };

    const deleteFont = async (font: Font) => {
        if (window.confirm("Voulez-vous vraiment supprimer cette police ?")) {
            await Fonts.remove(font);
            setNewFont(null);
        }
    };

    const handleAdd = () => setNewFont({
        "#type": TypeEnum.FONT,
        uid: InitUtils.uid(),
        family: "",
        font: null,
        format: FontFormatEnum.WOFF2,
        weights: [ 700 ],
        config: InitUtils.config(),
        idx: 0,
    });

    return (
        <>
            <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                <h2 className="mb-0 me-auto">Polices</h2>
                <BootstrapTooltip title="Ajouter">
                    <button type="button" className="btn btn-outline-primary btn-sm" onClick={handleAdd}>
                        <span className="bi-plus"></span>
                    </button>
                </BootstrapTooltip>
            </div>
            {null === newFont ? (
                <>
                    {/* @ts-expect-error react-sortablejs types incompatible with React 18 */}
                    <ReactSortable list={Fonts.all} setList={list => Fonts.set(list)} className="list-group mb-3">
                        {Fonts.all.map((((f, i) => (
                            <button
                                key={f.uid}
                                type="button"
                                className="d-flex justify-content-between align-items-center gap-1 list-group-item list-group-item-action"
                                onClick={() => setNewFont(f)}
                            >
                                <span className="me-auto">{f.family} ({f.weights.join(", ")})</span>
                                {0 === i ? (
                                    <span className="bi-star-fill text-warning fw-bolder" title="Par défaut"></span>
                                ) : null}
                                <span className="bi-grip-vertical cursor-grab ms-3"></span>
                            </button>
                        ))))}
                    </ReactSortable>
                </>
            ) : (
                <NavFontsCreate
                    font={newFont}
                    onSave={saveNewFont}
                    onDelete={deleteFont}
                    onCancel={() => setNewFont(null)}
                />
            )}
        </>
    );
}
